import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {PostAPICommand} from '@drl/core/api/commands';
import {environment} from '@drl/env/environment';

export class RefreshTokenCommand<T> extends PostAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>) {
    super(apiService, adapter, `${environment.authApiUrl}/auth/token-refresh`);
  }
}
